import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Check, Phone } from 'lucide-react';
import { CallListItem } from '../../types';
import { Button } from '../ui';
import { waLink } from './format';
import { WhatsAppIcon } from '../../pages/landing/data';

/**
 * One client to call after today's hearings: name, case, one-tap call and
 * WhatsApp buttons, and a local "called" checkmark (UI-only, resets on leave).
 */
export function CallListRow({ item }: { item: CallListItem }) {
  const [called, setCalled] = useState(false);
  const name = item.client?.name || item.client_name || 'Client';
  const phone = item.client?.phone || item.client?.whatsapp || null;
  const wa = item.client?.whatsapp || item.client?.phone || null;

  return (
    <div className="flex items-center gap-3 p-3">
      <button
        type="button"
        onClick={() => setCalled((v) => !v)}
        aria-pressed={called}
        aria-label={called ? `Mark ${name} as not called` : `Mark ${name} as called`}
        className={`shrink-0 h-6 w-6 rounded-full border flex items-center justify-center transition-colors ${
          called
            ? 'bg-emerald-500 border-emerald-500 text-white'
            : 'border-legal-300 text-transparent hover:border-emerald-400'
        }`}
      >
        <Check className="h-3.5 w-3.5" />
      </button>
      <div className="min-w-0 flex-1">
        <p className={`text-sm font-medium truncate ${called ? 'text-legal-400 line-through' : 'text-legal-900'}`}>
          {name}
        </p>
        <Link
          to={`/app/cases/${item.matter_id}`}
          className="text-xs text-legal-400 hover:text-accent-700 transition-colors truncate block"
        >
          {item.case_title}
        </Link>
      </div>
      {phone && (
        <Button
          variant="secondary"
          size="md"
          href={`tel:${phone}`}
          data-track="call-client"
          aria-label={`Call ${name}`}
          className="shrink-0 px-3"
        >
          <Phone className="h-4 w-4" />
        </Button>
      )}
      {wa && (
        <Button
          variant="secondary"
          size="md"
          href={waLink(wa)}
          target="_blank"
          rel="noopener noreferrer"
          data-track="call-client"
          aria-label={`WhatsApp ${name}`}
          className="shrink-0 px-3 text-[#25D366] hover:text-[#25D366]"
        >
          <WhatsAppIcon className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
}
